import Vuelidate from '@sword-health/vuelidate'
import InputErrorWuk from '@sword-health/web-ui-kit/src/components/inputs/footnotes/InputError.vue'
import vuelidateErrorExtractor from 'vuelidate-error-extractor'
import InputErrorMessage from '@/components/inputs/InputErrorMessage.vue'
import customValidatorMessages from './vuelidate-custom-validator-messages'

const vuelidateErrorExtractorOpts = {

  /**
   * Optionally provide the template in the configuration.
   * or register like so Vue.component("FormField", templates.singleErrorExtractor.foundation6)
   */
  name: 'InputErrorMessage',
  template: InputErrorMessage, // you can also pass your own custom template
  i18n: 'VALIDATIONS', // Path to validation messages. Can be deeply.nested.property.
  messages: {
    ...customValidatorMessages,
  },
}

export {
  Vuelidate,
  vuelidateErrorExtractor,
  vuelidateErrorExtractorOpts,
  InputErrorWuk,
}
